import React, { useState, useEffect } from 'react';
import {
  Box, Typography, Card, CardContent, Switch, FormControlLabel, Grid, Button, FormControl, InputLabel, Select, MenuItem
} from '@mui/material';
import axios from 'axios';
import swal from 'sweetalert';
import { useDeadline } from '../../../../contexts/DeadlineContext';
const ConferenceCurrencyEnableDisable = () => {
  const eventid = localStorage.getItem('eventid');
  const { abstractHomeSetup } = useDeadline();
  const gradientBackground = '#05597D';// Example gradient background
  const [defaultCurrency, setDefaultCurrency] = useState('ARE');
  const defaultCurrencyOptions = [
    { id: 1, value: 'SAR', label: 'Saudi Riyal' },
    { id: 2, value: 'ARE', label: 'UAE Dirham' },
    { id: 3, value: 'USA', label: 'US Dollar' }
  ];

  const [currencies, setCurrencies] = useState([
    { id: 1, name: 'Saudi Riyal', code: 'SAR', enabled: false },
    { id: 2, name: 'UAE Dirham', code: 'AED', enabled: false },
    { id: 3, name: 'US Dollar', code: 'USD', enabled: false }
  ]);
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);

  // Fetch currency settings from API
  useEffect(() => {
    const fetchCurrencySettings = async () => {
      try {
        const response = await axios.get(`/api/add-home-setup-index?id=${eventid}`);
        if (response.status === 200) {
          const data = response.data.HomePageSetup;
          console.log(data)
          setCurrencies([
            { id: 1, name: 'Saudi Riyal', code: 'SAR', enabled: data.saudi_riyal === 1 },
            { id: 2, name: 'UAE Dirham', code: 'AED', enabled: data.uae_darham === 1 },
            { id: 3, name: 'US Dollar', code: 'USD', enabled: data.usa_dollor === 1 }
          ]);
          setError(null);
        }
      } catch (err) {
        setError('Failed to fetch currency settings');
        console.error('Error fetching currency settings:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchCurrencySettings();
  }, [eventid]);

  const handleCurrencyChange = (event) => {
    const newCurrency = event.target.value;
    setDefaultCurrency(newCurrency);


  };

  const handleToggle = (id) => {
    setCurrencies(currencies.map(currency =>
      currency.id === id ? { ...currency, enabled: !currency.enabled } : currency
    ));
  };
  console.log("defaultCurrency", defaultCurrency)
  const submitCurrency = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError(null);

    try {
      const data = {
        eventid: eventid,
        saudi_riyal: currencies.find(c => c.code === 'SAR').enabled ? "1" : "0",
        uae_darham: currencies.find(c => c.code === 'AED').enabled ? "1" : "0",
        usa_dollor: currencies.find(c => c.code === 'USD').enabled ? "1" : "0",
        defaultCurrency: defaultCurrency,
      };

      const response = await axios.post('/api/add-currency-home-setup', data);

      if (response.status === 200) {
        swal({
          title: 'Success',
          text: response.data.message,
          icon: 'success',
          button: 'OK'
        });
      }
    } catch (err) {
      setError('Failed to update currency settings');
      console.error('Error updating currency settings:', err);
      swal({
        title: 'Error',
        text: 'Failed to update currency settings',
        icon: 'error',
        button: 'OK'
      });
    } finally {
      setSubmitting(false);
    }
  };

  if (loading) return <Box sx={{ p: 3, textAlign: 'center' }}>Loading currency settings...</Box>;
  if (error) return (
    <Box sx={{ p: 3, textAlign: 'center' }}>
      <Typography color="error.main">{error}</Typography>
      <Button onClick={() => window.location.reload()} sx={{ mt: 2 }}>
        Retry
      </Button>
    </Box>
  );

  return (
    <Box sx={{
      display: 'flex',
      justifyContent: 'center',
      width: '100%',
      p: 3
    }} component="form" onSubmit={submitCurrency} noValidate>
      <Box sx={{
        maxWidth: 600,
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
      }}>
        <Typography variant="h5" gutterBottom sx={{ mb: 3, textAlign: 'center', width: '100%' }}>
          Conference Currency Settings
        </Typography>

        <Card sx={{ width: '100%' }}>
          <CardContent>
            <Typography variant="subtitle1" color="text.secondary" sx={{ mb: 2, textAlign: 'center' }}>
              Enable/Disable Accepted Currencies
            </Typography>
            <Box sx={{ p: 2, display: 'flex', justifyContent: 'flex-end' }}>
              <FormControl sx={{ minWidth: 300 }}>
                <InputLabel>Default Currency</InputLabel>
                <Select
                  value={defaultCurrency}
                  label="Default Currency"
                  //onChange={(e) => setSelectedCurrency(e.target.value)}
                  onChange={handleCurrencyChange}

                >
                  {defaultCurrencyOptions.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>

            <Grid container spacing={3}>
              {currencies.map((currency) => (
                <Grid item xs={12} key={currency.id}>
                  <Box sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    p: 2,
                    border: '1px solid',
                    borderColor: 'divider',
                    borderRadius: 1,
                    bgcolor: currency.enabled ? 'action.selected' : 'background.paper'
                  }}>
                    <Box>
                      <Typography variant="body1" fontWeight="medium">
                        {currency.name} ({currency.code})
                      </Typography>
                      <Typography variant="caption" color="text.secondary">
                        {currency.enabled ? 'Enabled' : 'Disabled'}
                      </Typography>
                    </Box>

                    <FormControlLabel
                      control={
                        <Switch
                          checked={currency.enabled}
                          onChange={() => handleToggle(currency.id)}
                          color="primary"

                          disabled={submitting}
                        // sx={{
                        //   '& .MuiSwitch-thumb': {
                        //     backgroundColor: currency.enabled
                        //       ? abstractHomeSetup?.color_code_two || '#1976d2'
                        //       : undefined,
                        //   },
                        //   '& .MuiSwitch-track': {
                        //     backgroundColor: currency.enabled
                        //       ? abstractHomeSetup?.color_code_two || '#1976d2'
                        //       : undefined,
                        //   },
                        // }}
                        />
                      }
                      label={currency.enabled ? 'ON' : 'OFF'}
                      // label={
                      //   <Box
                      //     sx={{
                      //       px: 2,
                      //       py: 0.5,
                      //       borderRadius: 1,
                      //       backgroundColor: currency.enabled
                      //         ? abstractHomeSetup?.color_code_two || gradientBackground
                      //         : gradientBackground,
                      //       color: '#fff',
                      //       fontWeight: 500,
                      //     }}
                      //   >
                      //     {currency.enabled ? 'ON' : 'OFF'}
                      //   </Box>
                      // }
                      labelPlacement="start"
                    />
                  </Box>
                </Grid>
              ))}
            </Grid>
          </CardContent>
        </Card>

        <Box sx={{
          mt: 3,
          width: '100%',
          display: 'flex',
          justifyContent: 'center'
        }}>
          <Button
            variant="contained"
            type='submit'
            disabled={submitting}
            sx={{
              px: 3,
              py: 1,
              fontSize: 14,
              textTransform: 'none',
              backgroundColor: abstractHomeSetup?.color_code_two || gradientBackground,
            }}
          >
            {submitting ? 'Saving...' : 'Save Settings'}
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default ConferenceCurrencyEnableDisable;